module.exports = __webpack_public_path__ + "img/relationship.70443f98.svg";